import styled from 'styled-components/macro'

export const DateHeader = styled.div`
  border-bottom: 0.05em solid;
  padding-bottom: 0.4em;
  font-weight: bold;
  margin-bottom: 1rem;
`
